import { render, staticRenderFns } from "./ProductImageItem.vue?vue&type=template&id=c480fc06&scoped=true&lang=pug&"
import script from "./ProductImageItem.vue?vue&type=script&lang=js&"
export * from "./ProductImageItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductImageItem.vue?vue&type=style&index=0&id=c480fc06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c480fc06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VImg,VSpacer})
